module.exports = __webpack_public_path__ + "static/media/fly0158.b93cd60e.webp";